'use strict';
var Modal = require('../modalUtilities');

const currentPage = {
    isPLP: !! $('.full-page-plp').length,
    isSBL: !! $('.cc-product-set-detail').length
};

function lockBodyScroll() {
    const scrollY = $(window).scrollTop();
    $('body').css({
        position: 'fixed',
        top: `-${scrollY}px`,
        width: '100%'
    });
    $('body').data('scrollY', scrollY); // Store it for later
}

function unlockBodyScroll() {
    const html = $('html');
    const body = $('body');

    // Temporarily disable smooth scroll
    const originalScrollBehavior = html.css('scroll-behavior');
    html.css('scroll-behavior', 'auto');

    const scrollY = parseInt(body.data('scrollY')) || 0;
    body.css({
        position: '',
        top: '',
        width: ''
    });

    $(window).scrollTop(scrollY);

    // Restore scroll behavior
    window.requestAnimationFrame(() => {
        html.css('scroll-behavior', originalScrollBehavior);
    });
}

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} $icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, sku, $icon) {
    const statusSuccessClass = 'alert-success';
    const statusErrorClass = 'alert-danger';
    var status, messageModalDiv, backgroundProduct;
    if (data.success) {
        status = statusSuccessClass;
    } else {
        status = statusErrorClass;
    }

    var productMasterPid;
    if (data.productId) {
        productMasterPid = data.productId.replace(data.colorId, '');
    }

    if (!$('.js-wishlist-color-id-'.concat(sku, '')).length && !$('.js-wishlist-color-id-'.concat(productMasterPid, '')).length) {
        return;
    } else {
        if ($('.js-wishlist-color-id-'.concat(sku, '')).length > 0) {
            messageModalDiv = '.js-wishlist-color-id-'.concat(sku, '');
            backgroundProduct = sku;
        } else {
            messageModalDiv = '.js-wishlist-color-id-'.concat(productMasterPid, '');
            backgroundProduct = productMasterPid;
        }
    }

    $(messageModalDiv).find('.js-add-to-wishlist-message')
        .removeClass(statusSuccessClass).removeClass(statusErrorClass)
        .addClass(status).html(data.msg);

    let modalTarget = $(messageModalDiv);
    let modal = new Modal(modalTarget);
    var background = '.cc-add-to-wishlist-background.product-'.concat(backgroundProduct);
    $(background).show();
    $(messageModalDiv).show();

    lockBodyScroll();
    modal.open();

    setTimeout(function () {
        $('.js-close-add-to-wishlist-message').trigger('click');
        unlockBodyScroll();
    }, 2000);

    /* to implement if remove from wishlist required
    if ($icon) {
        var $emptyIcon = $icon.find('.cc-hover-icon.stroke');
        var $fillIcon = $icon.find('.cc-hover-icon.fill');

        $emptyIcon.hide();
        $fillIcon.show();
    }
    */
}

/**
 * fills or empties the heart icon for the specific product
 * @param {boolean} fill - true for filled heart, false for empty heart
 * @param {JQueryObject} $product - the jquery object of the current .js-singleItem-plp
 */
 function updateHeartIcon(fill, $product) {
    var $heart = $product.find('.js-add-to-wishlist');
    if (fill) {
        $heart.find('.stroke').addClass('cc-hide').css('display', 'none');
        $heart.find('.fill').removeClass('cc-hide').css('display', '');
    } else {
        // empty heart
        $heart.find('.fill').addClass('cc-hide').css('display', 'none');
        $heart.find('.stroke').removeClass('cc-hide').css('display', '');
    }
}

function getSelectedVariantPid($product) {
    var $analytics = $('.new-analytics', $product);

    // can't add outfit to wishlist, prevent request
    var isSet = $analytics.attr('data-isset') == 'true';
    if (isSet) return null;

    var color = $analytics.attr('data-color') || '';
    var size = $analytics.attr('data-size') || '';
    return $analytics.attr('data-pid') + color + size;  // pid concatenation wishlist
}

function checkProductInWishlist(pid, $plpProduct) {
    if (!pid) {
        return;
    }
    
    $.ajax({
        url: $('#wishlistContainsProductURL').val(),
        type: 'GET',
        data : {
            pid: pid
        },
        dataType: 'json',
        success: function(res) {
            if (! res.error) {
                updateHeartIcon(res.result, $plpProduct);
            }
        }
    });
}

function initWishlistScrollCheck() {
    let options = {
        rootMargin: `${parseInt(window.innerHeight * 0.35)}px 0px`,
        threshold: 0
    };

    let observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                var $element = $(entry.target);
                checkProductInWishlist(getSelectedVariantPid($element), $element);
                observer.unobserve(entry.target);
            }
        });
    }, options);

    var $productList = currentPage.isPLP ? $('.js-singleItem-plp .product') : $('.cc-product-list .product');
    $productList.each((_, productTile) => observer.observe(productTile));
    return observer;
}

module.exports = {
    addToWishlist: function () {
        $(document).on('click', '.js-add-to-wishlist', function (e) {
            e.preventDefault();
            var $icon = $(this);
            var url = $(this).data('href');
            var pid = $(this).data('pid');
            var colorId = $(this).data('color');
            var $productContainer = $(e.currentTarget).closest('.product');
            var size = null;
            var skuSelected = getSelectedVariantPid($productContainer);

            var optionId = null;
            var optionVal = null;
            if (!url || !pid || !colorId) {
                return;
            }

            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: skuSelected,
                    colorId: colorId,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    $.spinner().stop();
                    displayMessageAndChangeIcon(data, skuSelected, $icon);
                    // fill heart and trigger update for number of items in wishlist badge.
                    updateHeartIcon(true, $(e.target).closest('.product'));
                    $('body').trigger('wishlist:updateQuantity');
                    // analytics
                    dataLayer.push({
                        event: 'wishlist',
                        eventCategory: 'Wish List',
                        eventAction: 'add',
                        eventLabel: pid
                    });
                    // END
                },
                error: function (err) {
                    $.spinner().stop();
                    displayMessageAndChangeIcon(err, skuSelected, null);
                    $('body').trigger('wishlist:updateQuantity');
                }
            });
        });
    },

    closeModal: function () {
        $(document).on('click', '.js-close-add-to-wishlist-message', function(e) {
            let modalTarget = $(this).parent().parent();
            let modal = new Modal(modalTarget);

            $('.cc-add-to-wishlist-background').hide();
            modalTarget.hide();
            if (currentPage.isSBL) modal.close();
            if ($('body').hasClass('cc-blocked')) $('body').removeClass('cc-blocked');
            $('.js-add-to-wishlist').removeAttr('disabled');
        });
    },

    checkProductsInWishlist: function () {
        var intersectionObserver = initWishlistScrollCheck();

        $('body').on('wishlist:productsChangePLP', function() {
            intersectionObserver.disconnect();
            intersectionObserver = initWishlistScrollCheck();
        });

        $('body').on('wishlist:showMorePLP', function(_, data) {
            let startIndex = data.startIndex;
            $('.js-singleItem-plp').slice(startIndex).each((_, productTile) => {
                intersectionObserver.observe(productTile);
            });
        });

        $('body').on('wishlist:productVariationChange', function(_, data){
            let $element = data.$element;
            checkProductInWishlist(getSelectedVariantPid($element), $element);
        });
    }
};
